if (!customElements.get("variant-selects")) {
  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === "true";
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener("change", this.onVariantChange);
      this.other = Array.from(
        document.querySelectorAll("variant-selects")
      ).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest(".thb-product-detail");
      this.productSlider = this.productWrapper.querySelector(".product-images");
      this.hideVariants = this.dataset.hideVariants === "true";
      const lowP = document.querySelector("#am-omnibus-block");
      if (lowP) {
        new MutationObserver(() => {
          this.updateMinPrice(fryPrice);
        }).observe(lowP, { childList: true });
      }
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.toggleMediaUnavailableNotice();

      const trade_button = document.getElementById("trade-in-btn");
      const quick_link = document.getElementById("bid_quick_view_link");
      if (trade_button) trade_button.classList.remove("disabled-link");
      if (quick_link) {
        if (quick_link.dataset.disabled === "0") {
          quick_link.classList.remove("disabled-link");
        }
      }

      const dealer_text = document.getElementById("prod-sold-by");

      // hasRealVariant(), not a truthiness check: an unmatched combination now
      // yields an id-less placeholder, and it belongs in this "unavailable"
      // branch — which is what the code did before the placeholder was
      // introduced and started short-circuiting it.
      if (!this.hasRealVariant()) {
        this.toggleAddButton(true, "", true);
        this.setUnavailable();
        if (trade_button) trade_button.classList.add("disabled-link");
        if (quick_link) quick_link.classList.add("disabled-link");
        if (dealer_text) dealer_text.classList.add("hidden");
      } else {
        if (!this.currentVariant.available) {
          if (trade_button) trade_button.classList.add("disabled-link");
          if (quick_link) quick_link.classList.add("disabled-link");
        }

        if (quick_link) {
          quick_link.href = `${quick_link.dataset.url}?variant=${this.currentVariant.id}&bid=true`;
        }

        let d = this.currentVariant.option1.split("-");
        if (this.currentVariant.option1) {
          if (
            this.currentVariant.option1 == "Bikeroom" ||
            this.currentVariant.option1 == "002"
          ) {
            if (dealer_text) dealer_text.classList.add("hidden");
          } else {
            if (dealer_text) dealer_text.classList.remove("hidden");
          }
        }

        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateBid();
      this.watchProtectionPriceSource();

      // Page-load availability (product.variants | json) can be served stale
      // from Shopify's full-page CDN cache or a long-open tab. PR #81's
      // refreshAvailability() already corrects the "shown available but sold
      // out" direction reactively on the add-to-cart 422; the opposite,
      // "restocked but still struck-through", never triggers a 422 (the button
      // stays disabled, so it's never clicked). Reconcile once at load when
      // anything looks unavailable so a restocked size becomes selectable.
      // Skipped entirely on fully in-stock PDPs to avoid a needless fetch.
      if (this.getVariantData().some((variant) => variant.available === false)) {
        this.refreshAvailability();
      }
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, "", false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();
      this.toggleMediaUnavailableNotice();

      const trade_button = document.getElementById("trade-in-btn");
      const quick_link = document.getElementById("bid_quick_view_link");
      if (trade_button) trade_button.classList.remove("disabled-link");
      if (quick_link) {
        if (quick_link.dataset.disabled === "0") {
          quick_link.classList.remove("disabled-link");
        }
      }

      const dealer_text = document.getElementById("prod-sold-by");

      if (typeof priceChangeMutation !== "undefined") {
        priceChangeMutation.observe(
          document.getElementById(`price-${this.dataset.section}`),
          { childList: true, subtree: true }
        );
      }

      // hasRealVariant(), not a truthiness check: an unmatched combination now
      // yields an id-less placeholder, and it belongs in this "unavailable"
      // branch — which is what the code did before the placeholder was
      // introduced and started short-circuiting it.
      if (!this.hasRealVariant()) {
        this.toggleAddButton(true, "", true);
        this.setUnavailable();
        if (trade_button) trade_button.classList.add("disabled-link");
        if (quick_link) quick_link.classList.add("disabled-link");
        if (dealer_text) dealer_text.classList.add("hidden");
      } else {
        if (!this.currentVariant.available) {
          if (trade_button) trade_button.classList.add("disabled-link");
          if (quick_link) quick_link.classList.add("disabled-link");
        }

        if (quick_link) {
          quick_link.href = `${quick_link.dataset.url}?variant=${this.currentVariant.id}&bid=true`;
        }

        let d = this.currentVariant.option1.split("-");
        if (this.currentVariant.option1) {
          if (
            this.currentVariant.option1 == "Bikeroom" ||
            this.currentVariant.option1 == "002"
          ) {
            if (dealer_text) dealer_text.classList.add("hidden");
          } else {
            if (dealer_text) dealer_text.classList.remove("hidden");
          }
        }

        // Update services
        const limit = 2000;
        const ex = Shopify?.exchange_rate;
        const normalized_limit = limit * 100 * ex;

        let title = "Standard";
        let alt_title = "Standard";

        if (!this.currentVariant.taxable) {
          alt_title = "Margin";
          if (this.currentVariant.price > normalized_limit) {
            title = "Margin";
          } else {
            title = "Reduced_margin";
          }
        } else {
          alt_title = "Standard";
          if (this.currentVariant.price > normalized_limit) {
            title = "Standard";
          } else {
            title = "Reduced";
          }
        }

        const items = document.querySelectorAll(".prod-service-price");

        items.forEach((item) => {
          if (item.dataset.s == "true") {
            if (item.dataset.variant === title) {
              item.classList.remove("hidden");
              return;
            }
          } else {
            if (item.dataset.variant === alt_title) {
              item.classList.remove("hidden");
              return;
            }
          }

          item.classList.add("hidden");
        });


        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateOther();
      this.updateBid();

      this.updateMinPrice();

      if (bkrmPosthogReady() && this.hasRealVariant()) {
        bkrmTrack('product variant selected', {
          product_id: this.dataset.productId || undefined,
          variant_id: String(this.currentVariant.id),
          variant_title: this.currentVariant.title,
          available: this.currentVariant.available,
          price: this.currentVariant.price,
        });
      }

      dispatchCustomEvent("product:variant-change", {
        variant: this.currentVariant,
        sectionId: this.dataset.section,
      });
    }

    refreshAvailability() {
      const handleUrl = this.dataset.url;
      if (!handleUrl) return Promise.resolve();

      // Sequence token: a slow fetch for an earlier selection must not clobber
      // the state of a newer one.
      const token = (this.availabilityToken = (this.availabilityToken || 0) + 1);

      return fetch(`${handleUrl}.js`, { cache: "no-store" })
        .then((response) => (response.ok ? response.json() : null))
        .then((product) => {
          if (!product || !Array.isArray(product.variants)) return;
          if (token !== this.availabilityToken) return; // superseded

          const liveAvailability = new Map(
            product.variants.map((variant) => [variant.id, variant.available])
          );

          // Reconcile this selector and any mirror selector (e.g. the sticky
          // add-to-cart form keeps its own variant JSON copy).
          [this, ...this.other].forEach((selector) => {
            selector.getVariantData().forEach((variant) => {
              if (liveAvailability.has(variant.id)) {
                variant.available = liveAvailability.get(variant.id);
              }
            });
            selector.updateMasterId();
            selector.setDisabled();
          });

          if (!this.currentVariant || !this.currentVariant.available) {
            this.toggleAddButton(
              true,
              window.theme.variantStrings.soldOut,
              true
            );
          }
        })
        .catch(() => {});
    }

    updateBKRMProtectionPrice() {
      const protectionPriceSpan = document.getElementById('bkrm-protection-price');
      if (!protectionPriceSpan) return;
      // The customer-facing bike price can differ from currentVariant.price
      // when an external pricing app overrides the rendered amount
      // (`axt-cp-*` / `.axt_discounted_price`). Read the visible amount
      // first; fall back to variant.price for products without an override.
      // Returns null when no usable source is available (e.g. stub variant
      // built by setMasterId for unmatched option combinations) so the
      // span keeps its last valid value instead of collapsing to €0.
      const cents = this.readDisplayedPriceCents() ?? this.currentVariant?.price;
      if (!cents || cents <= 0 || !window.Shopify || !window.Shopify.formatMoney) return;
      const protection = (5000 * window.Shopify.exchange_rate) + (cents * 0.03);
      protectionPriceSpan.textContent = window.Shopify.formatMoney(cents + protection);
    }

    updateSavingPercentage() {
      // Recompute the "Save X%" badge from the *currently displayed* prices
      // so the value stays in sync with: (a) the customer-facing override
      // (`.axt_discounted_price`) injected by the pricing app, and (b) the
      // variant-specific compare_at_price, which differs across dealer/size/
      // color combinations on BKRM. The previous implementation pinned the
      // denominator to `product.compare_at_price` (server-rendered once =
      // the product-wide min), so swapping to a variant with a different
      // compare value produced a stale, misleading percentage — and a
      // locale-naive parser turned €5.500,00 into 5.5, yielding "Save 100%".
      const container = document.getElementById(`price-${this.dataset.section}`);
      if (!container) return;
      const discountLabel = container.querySelector('[id^="p-disc-"]');
      if (!discountLabel) return;
      const template = discountLabel.dataset.saveTemplate;
      if (!template) return; // only active when sale_badge_type == 'save_percentage'
      const compareEl = container.querySelector('[id^="compare-"]');
      if (!compareEl) return;
      const priceCents = this.readDisplayedPriceCents();
      const compareCents = this.readDisplayedPriceCents(compareEl);
      if (!priceCents || !compareCents || compareCents <= priceCents) return;
      const pct = Math.round(((compareCents - priceCents) * 100) / compareCents);
      const next = template.replace('__PCT__', `${pct}%`);
      if (discountLabel.innerHTML !== next) discountLabel.innerHTML = next;
    }

    readDisplayedPriceCents(element) {
      let el = element;
      if (!el) {
        const container = document.getElementById(`price-${this.dataset.section}`);
        if (!container) return null;
        el = container.querySelector('.axt_discounted_price')
          || container.querySelector('.amount > span');
      }
      const text = el?.textContent;
      if (!text) return null;
      // Keep only digits and separators, then trim stray separators left by the
      // currency symbol itself: e.g. "Dhs. 20,445.00" survives the strip as
      // ".20,445.00", and a naive parseFloat would stop at the second dot and
      // read 0.20445. AED/KRW etc. broke here; EUR happened to survive.
      const stripped = text.replace(/[^\d.,]/g, '').replace(/^[.,]+/, '').replace(/[.,]+$/, '');
      if (!stripped) return null;
      // Don't guess the decimal separator from position — Shopify Markets
      // localizes Shopify.money_format per currency, so read the convention
      // straight from it:
      //   "Dhs. {{amount}}"                       -> 2 decimals, "." decimal
      //   "€{{amount_with_comma_separator}}"      -> 2 decimals, "," decimal
      //   "{{amount_with_space_separator}} kr"    -> 2 decimals, "," decimal (SEK)
      //   "₩{{amount_no_decimals}}"               -> 0 decimals (every separator is grouping)
      const fmt = (window.Shopify && Shopify.money_format) || '';
      let normalized;
      if (/amount_no_decimals/.test(fmt)) {
        normalized = stripped.replace(/[.,]/g, '');
      } else {
        // Comma-decimal formats: the explicit comma one, plus
        // `amount_with_space_separator` (SEK/NOK/CZK/PLN…) which groups with a
        // space and *also* uses a comma decimal — the reason Sweden read 100x
        // high. `amount_with_period_and_space_separator` keeps a period decimal
        // and deliberately does not match this test.
        const decimalSep = /with_comma_separator|amount_with_space_separator/.test(fmt)
          ? ','
          : '.';
        const i = stripped.lastIndexOf(decimalSep);
        normalized = i === -1
          ? stripped.replace(/[.,]/g, '')
          : stripped.slice(0, i).replace(/[.,]/g, '') + '.' + stripped.slice(i + 1);
      }
      const n = parseFloat(normalized);
      if (!Number.isFinite(n)) return null;
      return Math.round(n * 100);
    }

    watchProtectionPriceSource() {
      const container = document.getElementById(`price-${this.dataset.section}`);
      if (!container) return;
      this._protectionObserver?.disconnect();
      this._protectionObserver = new MutationObserver(() => {
        this.updateBKRMProtectionPrice();
        this.updateSavingPercentage();
      });
      this._protectionObserver.observe(container, {
        childList: true,
        subtree: true,
        characterData: true,
      });
      // Initial sync in case the displayed price was already mutated by
      // an app before this observer attached.
      this.updateBKRMProtectionPrice();
      this.updateSavingPercentage();
      window.addEventListener('load', (e) => {
        this.updateBKRMProtectionPrice();
        this.updateSavingPercentage();
      })
    }

    updateBid() {
      let bidBtn = document.getElementById("bid-dialog-open-btn");
      if (!this.currentVariant) {
        if (bidBtn) bidBtn.classList.add("disabled-link");
      } else {
        if (!bidBtn) return;

        if (this.currentVariant.available == false) {
          bidBtn.classList.add("disabled-link");
          return;
        }

        if (!enabledVariants || !enabledVariants[this.currentVariant.id]) {
          bidBtn.classList.add("disabled-link");
          return;
        }

        if (
          this.currentVariant.options[0] == "091" ||
          this.currentVariant.options[0] == "096" ||
          this.currentVariant.options[0] == "Zyclora.it" ||
          this.currentVariant.options[0] == "TUVALUM SPORTS SL"
        ) {
          bidBtn.classList.add("disabled-link");
          return;
        }


        
        
        bidBtn.classList.remove("disabled-link");

        // Bottone "Request a price" (bid spento da settings.bid_enabled,
        // sopra soglia, UK, tag "price request"): non sta in un
        // <modal-opener>, quindi niente switch bid/bidform. Senza questo
        // return il try qui sotto leggeva dataset.modal del wrapper
        // (undefined) e loggava un TypeError a ogni cambio variante.
        if (bidBtn.classList.contains("js-request-price")) return;

        // Il flusso bid vive nel <bike-configurator> (modalità bid): i dati
        // per matrice/pannello offerta si aggiornano via l'evento
        // product:variant-change (onVariantChange in product-configurator.js).
        // Qui resta solo il gating del bottone e lo switch bid/bidform.
        let price = this.currentVariant.price / 100;

        try {
          const limit = 8000 * Shopify.exchange_rate;
          let d = bidBtn.parentElement.dataset.modal;
          d = d.split("-");

          const countryNotAllowed = bidBtn.parentElement.dataset.market == 'united-kingdom';

          if (price >= limit || countryNotAllowed) {
            d[1] = "bidform";
            bidBtn.children[0].innerHTML = bidBtn.parentElement.dataset.form;
          } else {
            d[1] = "bid";
            bidBtn.children[0].innerHTML = bidBtn.parentElement.dataset.text;
          }
          d = d.join("-");
          bidBtn.parentElement.dataset.modal = d;
        } catch (e) {
          console.error(e);
        }
      }
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector("select")) {
          this.options.push(fieldset.querySelector("select").value);
        } else if (fieldset.querySelectorAll("input").length) {
          this.options.push(fieldset.querySelector("input:checked").value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector(".form__label__value");
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    // updateMasterId() {
    //   this.currentVariant = this.getVariantData().find((variant) => {
    //     return !variant.options.map((option, index) => {
    //       return this.options[index] === option;
    //     }).includes(false);
    //   });
    // }

    updateMasterId() {
      const v = this.getVariantData().toSorted((a, b) => {
        const nameA = a.option1.toUpperCase(); // ignore upper and lowercase
        const nameB = b.option1.toUpperCase(); // ignore upper and lowercase

        if (nameA === "BIKEROOM" || nameA === "002") {
          return -1;
        }
        if (nameB === "BIKEROOM" || nameB === "002") {
          return 1;
        }

        if (a.price < b.price) {
          return -1;
        }
        if (a.price > b.price) {
          return 1;
        }

        // names must be equal
        return 0;
      });

      this.currentVariant = v.find((variant) => {
        if (shopify_meta_hide[variant.id]) {
          return false;
        }
        if (variant.available === false) {
          return false;
        }
        return !variant.options
          .map((option, index) => {
            if (index === dealerOptionIndex) {
              return true;
            }
            return this.options[index] === option;
          })
          .includes(false);
      });
      if (this.currentVariant === undefined) {
        this.currentVariant = v.find((variant) => {
          if (shopify_meta_hide[variant.id]) {
            return false;
          }
          return !variant.options
            .map((option, index) => {
              if (index === dealerOptionIndex) {
                return true;
              }
              return this.options[index] === option;
            })
            .includes(false);
        });
      }
      // No variant matches the picked options — an incomplete option grid (a
      // colour that exists in only some sizes, or two option values that differ
      // only by casing, as on the Pinarello Dogma frameset: "Edge White" vs
      // "edge white"). Keep a placeholder so the UI can still show WHAT the
      // customer picked, but with `id: null` and `synthetic: true`: the id is
      // the one field that must never be invented. A made-up id used to reach
      // the form's [name=id], ?variant= and the configurator's
      // data-bike-variant-id, and Shopify resolves an unknown variant id to the
      // product's first available variant — so the customer silently ended up
      // bidding on a different colour (Asana 1217408195587196).
      if (this.currentVariant === undefined) {
        this.currentVariant = {
          option1: this.options[0],
          option2: this.options[1],
          option3: this.options[2],
          id: null,
          synthetic: true,
          options: this.options,
          available: false,
          title: this.options.join(" / "),
        };
      }
      //console.log("DEALER:", this.currentVariant?.option1)
    }

    /**
     * True only when the current selection resolves to a real catalog variant.
     * The placeholder built at the end of updateMasterId() carries the picked
     * option values but no id, so anything that publishes variant IDENTITY
     * (form input, URL, section fetch, analytics, variant-change event) must
     * gate on this rather than on `this.currentVariant` being truthy.
     */
    hasRealVariant() {
      return Boolean(this.currentVariant && this.currentVariant.id != null);
    }

    updateOther() {
      if (this.dataset.updateUrl === "false") {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll("fieldset"),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector("select")) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll("input").length) {
            fieldsets_array[i].querySelector(
              `input[value='${option}']`
            ).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    /**
     * Toggles the "this colour has no photo of its own" notice.
     *
     * The markup only exists on products that attach at least one image to a
     * variant (sections/main-product.liquid stamps
     * data-variant-image-required for those). There, a variant with no
     * featured_media means updateMedia() below bails out and the gallery keeps
     * showing whichever colour was on screen — the confusion reported in Asana
     * 1217535996010092. Products photographed as a single set carry no notice
     * markup at all, so this is a no-op for them.
     */
    toggleMediaUnavailableNotice() {
      const notice = document.querySelector(
        ".thb-product-detail .product-image-container[data-variant-image-required] [data-media-unavailable-notice]"
      );
      if (!notice) return;
      notice.hidden = Boolean(this.currentVariant?.featured_media);
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let productSlider = document.querySelector(
          ".thb-product-detail .product-images"
        ),
        thumbnails = document.querySelector(
          ".thb-product-detail #Product-Thumbnails"
        );

      this.setActiveMedia(
        `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        productSlider,
        thumbnails
      );
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider?.querySelector(mediaId);

      if (flkty && this.hideVariants) {
        if (
          productSlider?.querySelector(
            ".product-images__slide.is-initial-selected"
          )
        ) {
          productSlider
            ?.querySelector(".product-images__slide.is-initial-selected")
            ?.classList.remove("is-initial-selected");
        }
        [].forEach.call(
          productSlider?.querySelectorAll(
            ".product-images__slide-item--variant"
          ),
          function (el) {
            el?.classList.remove("is-active");
          }
        );

        activeMedia?.classList.add("is-active");
        activeMedia?.classList.add("is-initial-selected");

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails?.querySelector(thumbId);

          if (
            thumbnails?.querySelector(".product-thumbnail.is-initial-selected")
          ) {
            thumbnails
              ?.querySelector(".product-thumbnail.is-initial-selected")
              ?.classList.remove("is-initial-selected");
          }
          [].forEach.call(
            thumbnails?.querySelectorAll(
              ".product-images__slide-item--variant"
            ),
            function (el) {
              el?.classList.remove("is-active");
            }
          );

          activeThumb?.classList.add("is-active");
          activeThumb?.classList.add("is-initial-selected");
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);
      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

      const currentImage =
        document.querySelector(mediaId)?.firstElementChild.children[1];
      if (currentImage?.src) {
        let im = document.getElementById(
          "product-sel-variant-hotspot"
        )?.firstElementChild;

        if (!im) return;
        let rep = currentImage.cloneNode(false);
        im.replaceWith(rep);
        im.setAttribute(
          "style",
          "mix-blend-mode: multiply; padding-right: 10px; padding-left: 10px;"
        );
      }
    }

    updateURL() {
      // An unmatched combination leaves the URL on the last real variant: a
      // ?variant= that isn't in the catalog is not "no variant" to Shopify, it
      // silently falls back to the first available one on the next page load.
      if (!this.hasRealVariant() || this.dataset.updateUrl === "false") return;
      // Preserve any other query params already on the URL (e.g. the bid
      // dialog's `?value=<offer>` resume flag written before the login
      // redirect, dialog-bid.liquid openLogin()) — overwriting the whole
      // search string with just `variant` silently dropped them, so the
      // page never noticed it should reopen the bid dialog after login.
      const params = new URLSearchParams(window.location.search);
      params.set("variant", this.currentVariant.id);
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?${params.toString()}`
      );
    }

    updateShareUrl() {
      const shareButton = document.getElementById(
        `Share-${this.dataset.section}`
      );
      if (!shareButton || !this.hasRealVariant()) return;
      shareButton.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }

    updateVariantInput() {
      // Never point the form at an id that isn't in the catalog. The caller
      // already routes unmatched combinations to the "unavailable" branch (the
      // CTA is disabled there), so leaving the last real id in place is safe.
      if (!this.hasRealVariant()) return;
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(
          new Event("change", {
            bubbles: true,
          })
        );
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector(
        ".pickup-availability-wrapper"
      );

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.innerHTML = "";
      }
    }

    removeErrorMessage() {
      const section = this.closest("section");
      if (!section) return;

      const productForm = section.querySelector("product-form");
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [
        `price-${this.dataset.section}`,
        `price-${this.dataset.section}--sticky`,
        `product-image-${this.dataset.section}--sticky`,
        `inventory-${this.dataset.section}`,
        `sku-${this.dataset.section}`,
        `quantity-${this.dataset.section}`,
      ];
    }

    renderProductInfo() {
      // Fetching `?variant=<unknown id>` returns the section rendered for the
      // product's FIRST AVAILABLE variant, and the code below copies that price,
      // SKU and sticky image into the page — which is exactly how a customer saw
      // another colour's data appear after picking a combination that has no
      // variant. Keep the last real variant's info instead.
      if (!this.hasRealVariant()) return;
      let sections = this.getSectionsToRender();

      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + "--sticky");

            if (price) price.classList.remove("visibility-hidden");
            if (price_fixed) price_fixed.classList.remove("visibility-hidden");
          });
          this.toggleAddButton(
            !this.currentVariant.available,
            window.theme.variantStrings.soldOut
          );
          // Il swap di innerHTML sopra rimpiazza i nodi della zona prezzo
          // con markup server (chip sconto "Save X%" inclusa): ri-applica
          // le trasformazioni della variante esperimento (no-op senza flag
          // o fuori dai template marcati).
          if (typeof bkrmApplyBuyboxVariant === "function")
            bkrmApplyBuyboxVariant();
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(
        `product-form-${this.dataset.section}`
      );
      if (!productForm) return;

      const productTemplate = productForm
        .closest(".product-form")
        .getAttribute("template");
      const submitButtons = document.querySelectorAll(
        ".single-add-to-cart-button"
      );

      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector(
          ".single-add-to-cart-button--text"
        );

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute("disabled", "disabled");
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute("disabled");
          submitButton.classList.remove("loading");

          if (productTemplate?.includes("pre-order")) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent =
              window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll(
        ".single-add-to-cart-button"
      );
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(
        `price-${this.dataset.section}--sticky`
      );
      const trade_button = document.getElementById("trade-in-btn");

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector(
          ".single-add-to-cart-button--text"
        );
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add("sold-out");
      });
      if (price) price.classList.add("visibility-hidden");
      if (price_fixed) price_fixed.classList.add("visibility-hidden");
      if (trade_button) trade_button.disabled = true;
    }

    setDisabled() {
      if (this.isDisabledFeature != "true") {
        return;
      }
      const variant_data = this.getVariantData();

      if (variant_data) {
        const selected_options = this.currentVariant?.options.map(
          (value, index) => {
            return {
              value,
              index: `option${index + 1}`,
            };
          }
        );
        const available_options = this.createAvailableOptionsTree(
          variant_data,
          selected_options
        );

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector("select")) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]"
                  ).disabled = true;
                } else {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]"
                  ).disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll("input").length) {
              fieldset.querySelectorAll("input").forEach((input) => {
                // Match by value, not by index. The availability tree is built
                // in variant order, which can differ from the input DOM order
                // (e.g. sizes rendered ascending while variants are stored in
                // another order). Indexing crosses out the wrong option — the
                // root cause of "sold-out variant shown as available".
                const option = fieldset_options.find(
                  (o) => o.value === input.value
                );
                if (option) {
                  input.classList.toggle("is-disabled", option.isUnavailable);
                }
              });
            }
          }
        });
      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, "");
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector("[data-set-name]");
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector(
          '.product-form__input[data-handle="' + this.imageSetName + '"]'
        ).dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(
        this.currentVariant[this.imageSetIndex]
      );
      let group = this.imageSetName + "_" + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(
          `.product-images__slide[data-set-name="${this.imageSetName}"]`
        ),
        selected_set_thumbs = this.productWrapper.querySelectorAll(
          `.product-thumbnail[data-set-name="${this.imageSetName}"]`
        );

      if (this.hideVariants) {
        // Product images
        this.productWrapper
          .querySelectorAll(".product-images__slide")
          .forEach((thumb) => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove("is-active");
            }
          });
        selected_set_images.forEach((thumb) => {
          thumb.classList.toggle("is-active", thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper
          .querySelectorAll(".product-thumbnail")
          .forEach((thumb) => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove("is-active");
            }
          });
        selected_set_thumbs.forEach((thumb) => {
          thumb.classList.toggle("is-active", thumb.dataset.group === group);
        });
      }
    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce(
        (options, variant) => {
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach((index) => {
            if (variant[index] === null) return;

            // let another_entry_active = options[index].some(option => option.value === variant[index] && !option.isUnavailable);

            let entry = options[index].find(
              (option) => option.value === variant[index]
            );

            if (typeof entry === "undefined") {
              // If option has yet to be added to the options tree, add it
              entry = {
                value: variant[index],
                isUnavailable: true,
              };
              options[index].push(entry);
            }

            // Check how many selected option values match a variant
            const countVariantOptionsThatMatchCurrent =
              selected_options?.reduce((count, { value, index }) => {
                return variant[index] === value ||
                  index === "option" + (dealerOptionIndex + 1)
                  ? count + 1
                  : count;
              }, 0);
            //console.log(countVariantOptionsThatMatchCurrent)
            //console.log(entry)
            // Only enable an option if an available variant matches all but one current selected value
            if (
              countVariantOptionsThatMatchCurrent >=
              selected_options?.length - 1
            ) {
              entry.isUnavailable =
                entry.isUnavailable &&
                (variant.available && !shopify_meta_hide[variant.id]
                  ? false
                  : entry.isUnavailable);
            }
            //console.log(entry)
            // if(selected_options?.find((option) =>  || (option.value === entry.value && index === option.index))) {
            //   entry.isUnavailable = entry.isUnavailable && variant.available ? shopify_meta_hide[variant.id] : entry.isUnavailable;
            // }

            // entry.isUnavailable = entry.isUnavailable && variant.available ? shopify_meta_hide[variant.id] : entry.isUnavailable;
            // Make sure if a variant is unavailable, disable currently selected option
            if (
              (!this.currentVariant || !this.currentVariant.available) &&
              selected_options?.find(
                (option) =>
                  variant.available &&
                  !shopify_meta_hide[variant.id] &&
                  option.value === entry.value &&
                  index === option.index
              )
            ) {
              entry.isUnavailable = true;
            }
            //console.log(entry)
            // NOTE: there used to be an extra branch here that enabled every
            // entry of the first non-dealer option (Size) as soon as ANY
            // available variant carried that value, ignoring the currently
            // selected colour. On a Dealer/Size/Color product that made all
            // sizes look available whatever colour was picked (Asana
            // 1217400243631758). The generic
            // countVariantOptionsThatMatchCurrent rule above already covers the
            // two-option case it was written for — with Dealer always counting
            // as a match, the threshold there is satisfied by any variant — so
            // dropping the branch only changes the three-option case, which is
            // the broken one.
          });

          //console.log(variant)

          //console.log(JSON.stringify(options))

          return options;
        },
        {
          option1: [],
          option2: [],
          option3: [],
        }
      );
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    updateMinPrice(price) {
      const m =
        document.querySelector("#am-omnibus-block")?.children[0]?.innerHTML;

      if (!m) return;

      if (!this.currentVariant && !price) {
        const cont =
          document.querySelector("#am-omnibus-block").parentElement
            .parentElement;
        if (cont) {
          cont.classList.add("hidden");
        }
        return;
      }

      const cr = Shopify.exchange_rate / Shopify.currency.rate;

      let p = price ?? this.currentVariant?.price;
      p = p / 100;

      p = p / Shopify.currency.rate;

      let ngp = m.split(":");
      ngp = ngp[1];
      ngp = ngp?.split("<")[0];
      ngp = Number(ngp.replace(/[^0-9]+/g, "")) / 100;

      let gp = (ngp * cr) / Shopify.currency.rate;

      const cont =
        document.querySelector("#am-omnibus-block").parentElement.parentElement;

      let ht = m.split(":");
      ht[1] = ht[1].split("<");
      ht[1][0] = Shopify.formatMoney(Math.round(ngp * cr) * 100) + " ";

      ht[1] = ht[1].join("<");
      ht = ht.join(": ");

      if (Math.abs(gp - p) > 5) {
        if (!cont) return;
        if (!cont.querySelector(".tooltip")) {
          const tooltip = `
											<div class="tooltip" style="padding-top: 2px">
												<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path d="M7.45 11.6166H8.56666V7.7166H7.45V11.6166ZM7.99473 6.5666C8.1538 6.5666 8.28889 6.5128 8.4 6.4052C8.51111 6.2976 8.56666 6.16427 8.56666 6.0052C8.56666 5.84613 8.51286 5.71105 8.40526 5.59994C8.29766 5.48882 8.16433 5.43327 8.00526 5.43327C7.8462 5.43327 7.71111 5.48707 7.6 5.59467C7.48888 5.70227 7.43333 5.8356 7.43333 5.99467C7.43333 6.15374 7.48713 6.28882 7.59473 6.39994C7.70233 6.51105 7.83566 6.5666 7.99473 6.5666ZM8.0046 14.7333C7.14701 14.7333 6.33956 14.5707 5.58225 14.2456C4.82492 13.9204 4.16216 13.4732 3.59396 12.9039C3.02576 12.3346 2.57916 11.6719 2.25416 10.9158C1.92916 10.1598 1.76666 9.35193 1.76666 8.4923C1.76666 7.63176 1.92923 6.82561 2.25438 6.07385C2.57952 5.32209 3.02675 4.6621 3.59605 4.0939C4.16535 3.5257 4.82803 3.0791 5.5841 2.7541C6.34015 2.4291 7.148 2.2666 8.00763 2.2666C8.86817 2.2666 9.67432 2.42917 10.4261 2.75432C11.1778 3.07946 11.8378 3.52668 12.406 4.09599C12.9742 4.66529 13.4208 5.32667 13.7458 6.08014C14.0708 6.83359 14.2333 7.63866 14.2333 8.49534C14.2333 9.35292 14.0708 10.1604 13.7456 10.9177C13.4205 11.675 12.9732 12.3378 12.4039 12.906C11.8346 13.4742 11.1733 13.9208 10.4198 14.2458C9.66634 14.5708 8.86127 14.7333 8.0046 14.7333ZM8 13.6166C9.41666 13.6166 10.6236 13.118 11.6208 12.1208C12.6181 11.1235 13.1167 9.9166 13.1167 8.49994C13.1167 7.08327 12.6181 5.87632 11.6208 4.8791C10.6236 3.88188 9.41666 3.38327 8 3.38327C6.58333 3.38327 5.37638 3.88188 4.37916 4.8791C3.38194 5.87632 2.88333 7.08327 2.88333 8.49994C2.88333 9.9166 3.38194 11.1235 4.37916 12.1208C5.37638 13.118 6.58333 13.6166 8 13.6166Z" fill="#6A6C6F"/>
												</svg>
												<span class="tooltiptext">${fryTooltopText}</span>
											</div>
										`;
          cont.insertAdjacentHTML("beforeend", tooltip);
        }

        let bbb = document.querySelector("#am-omnibus-block")?.children[0];
        if (bbb) {
          bbb.innerHTML = ht;
        }

        cont.classList.add("jsb");
        cont.classList.remove("hidden");
      } else {
        if (!cont) return;
        cont.classList.add("hidden");
      }
    }
  }
  customElements.define("variant-selects", VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      });
    }
  }

  customElements.define("variant-radios", VariantRadios);
}

if (!customElements.get("product-slider")) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener("change", this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest(".thb-product-detail");
      this.thumbnail_container = this.product_container.querySelector(
        ".product-thumbnail-container"
      );
      this.video_containers = this.querySelectorAll(
        ".product-single__media-external-video--play"
      );

      this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == "true";
      this.thumbnails =
        this.thumbnail_container.querySelectorAll(".product-thumbnail");
      this.prev_button = this.querySelector(".flickity-prev");
      this.next_button = this.querySelector(".flickity-next");
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: ".is-initial-selected",
        prevNextButtons: false,
        fade: false,
        cellSelector: ".product-images__slide.is-active",
      };
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {
      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener("click", (event) => {
          this.flkty.previous();
        });
        prev.addEventListener("keyup", (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener("click", (event) => {
          this.flkty.next();
        });
        next.addEventListener("keyup", (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container
          .querySelector("button")
          .addEventListener("click", function () {
            container.setAttribute("hidden", "");
          });
      });
      this.flkty.on("settle", function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on("change", (index) => {
        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector(
            ".product-single__media"
          ),
          active_thumbs = Array.from(this.thumbnails).filter((element) =>
            element.classList.contains("is-active")
          ),
          active_thumb = active_thumbs[index]
            ? active_thumbs[index]
            : active_thumbs[0];

        this.thumbnails.forEach((item, i) => {
          item.classList.remove("is-initial-selected");
        });
        active_thumb.classList.add("is-initial-selected");

        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left:
              active_thumb.offsetLeft -
              windowHalfWidth +
              active_thumb.clientWidth / 2,
            top:
              active_thumb.offsetTop -
              windowHalfHeight +
              active_thumb.clientHeight / 2,
            behavior: "smooth",
          });
        });

        // Stop previous video
        if (
          previous_media.classList.contains(
            "product-single__media-external-video"
          )
        ) {
          if (previous_media.dataset.provider === "youtube") {
            previous_media.querySelector("iframe").contentWindow.postMessage(
              JSON.stringify({
                event: "command",
                func: "pauseVideo",
                args: "",
              }),
              "*"
            );
          } else if (previous_media.dataset.provider === "vimeo") {
            previous_media.querySelector("iframe").contentWindow.postMessage(
              JSON.stringify({
                method: "pause",
              }),
              "*"
            );
          }
          previous_media
            .querySelector(".product-single__media-external-video--play")
            .removeAttribute("hidden");
        } else if (
          previous_media.classList.contains(
            "product-single__media-native-video"
          )
        ) {
          previous_media.querySelector("video").pause();
        }
      });

      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(
          (element) => element.clientWidth > 0
        );
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener("click", () => {
            this.thumbnailClick(thumbnail, index);
          });
        });
      });
    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove("is-initial-selected");
      });
      thumbnail.classList.add("is-initial-selected");
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll(".product-single__media-zoom").length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(
        this.querySelectorAll(
          ".product-images__slide.is-active .product-single__media-image"
        )
      );

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(
          item.parentNode.parentNode.children,
          item.parentNode
        );

        let activelink = item.querySelector(".product-single__media-zoom");

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute("href"),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll(".product-single__media-zoom");
      this.pswpElement = document.querySelectorAll(".pswp")[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector(
              ".product-images__slide.is-selected"
            ),
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width,
          };
        },
      };

      this.links.forEach((link) => {
        link.addEventListener("click", (e) => this.zoomClick(e, link));
      });
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== "undefined") {
        let pswp = new PhotoSwipe(
          this.pswpElement,
          PhotoSwipeUI_Default,
          this.items,
          this.pswpOptions
        );
        pswp.listen("firstUpdate", function () {
          pswp.listen("parseVerticalMargin", function (item) {
            item.vGap = {
              top: 50,
              bottom: 50,
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define("product-slider", ProductSlider);
}

// Eventi CTA con nome distinto (sync funnel 30-07): "cta clicked.<cta_type>",
// un nome-evento per CTA, componibile nei funnel PostHog senza breakdown.
// Il "." non ha semantica in PostHog: è solo un prefisso che raggruppa gli
// eventi nel picker. Il suffisso è SEMPRE il valore di cta_type, mai testo
// libero. Un'azione emette UN solo evento — niente generico in parallelo,
// così nessun insight può contare doppio: il "qualsiasi CTA" è l'Action
// PostHog "cta clicked (any)", che è una vista e non genera eventi.
function bkrmCaptureCta(props) {
  bkrmTrack("cta clicked." + props.cta_type, props);
}

// `window.posthog` non basta come guardia: lo snippet in theme.liquid assegna
// `window.posthog = []` (array: truthy) e crea i metodi-coda (capture, ...)
// solo DENTRO init(). Senza init - il tema lo salta sotto automazione
// (navigator.webdriver), e un'estensione privacy puo' lasciare lo stub a meta' -
// `posthog.capture` e' undefined e la vecchia guardia lasciava passare una
// chiamata che LANCIA. Qui costava l'acquisto: il throw in connectedCallback
// ("product viewed") e nell'handler di submit, che sta PRIMA del blocco che
// apre il configuratore, lasciava il click su "Add to cart" senza alcun
// effetto. Asana 1217141601941185.
function bkrmPosthogReady() {
  return !!(window.posthog && typeof window.posthog.capture === "function");
}

function bkrmTrack(event, props) {
  try {
    if (bkrmPosthogReady()) window.posthog.capture(event, props);
  } catch (err) {
    if (window.console && window.console.debug)
      window.console.debug("[bkrm] analytics skipped:", event, err);
  }
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.sticky = this.dataset.sticky;
        this.form = document.getElementById(
          `product-form-${this.dataset.section}`
        );
        this.form.querySelector("[name=id]").disabled = false;
        if (!this.sticky) {
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
          // "product viewed" deve scattare UNA volta per pageload, ma
          // connectedCallback riesegue su re-render di sezione (theme editor,
          // Section Rendering API) e su quick-view: il flag su window è
          // l'unico stato che sopravvive alla sostituzione del nodo. Il check
          // sul body esclude i mount fuori dalla PDP (es. quick-view in
          // collection), dove l'evento non è una vista prodotto.
          if (
            !window.__bkrmProductViewed &&
            bkrmPosthogReady() &&
            document.body.classList.contains("template-product")
          ) {
            window.__bkrmProductViewed = true;
            bkrmTrack("product viewed", {
              product_id: this.dataset.productId || undefined,
              product_type: this.dataset.productType || undefined,
              template_suffix: this.getAttribute("template") || undefined,
            });
          }
          // Il CTA "Place a bid" (#bid-dialog-open-btn, reso da dialog-bid
          // dentro questo form) non passa dal submit: senza questo listener
          // il funnel non vedrebbe mai cta_type=place_bid. Dedup via
          // data-attr: connectedCallback può rieseguire sullo stesso nodo.
          const bidCta = this.querySelector("#bid-dialog-open-btn");
          if (bidCta && !bidCta.dataset.bkrmCtaTracked) {
            bidCta.dataset.bkrmCtaTracked = "true";
            bidCta.addEventListener("click", () => {
              // Specchia i no-op di openBidConfigurator (dialog-bid.liquid),
              // valutati AL CLICK perché updateBid() può riconfigurare il
              // bottone a runtime (UK / sopra soglia): js-request-price e
              // l'opener '-bidform-' aprono form di richiesta, non il flusso
              // bid — contarli gonfierebbe il funnel place_bid.
              if (bidCta.classList.contains("js-request-price")) return;
              const opener = bidCta.closest("modal-opener");
              if (
                opener &&
                (opener.dataset.modal || "").indexOf("-bidform-") !== -1
              ) {
                return;
              }
              if (
                bkrmPosthogReady() &&
                document.body.classList.contains("template-product")
              ) {
                bkrmCaptureCta({
                  cta_type: "place_bid",
                  surface: "inline",
                  product_id: this.dataset.productId || undefined,
                  product_type: this.dataset.productType || undefined,
                  template_suffix: this.getAttribute("template") || undefined,
                });
              }
            });
          }
        }
        this.cartNotification = document.querySelector("cart-notification");
        this.body = document.body;

        this.hideErrors = this.dataset.hideErrors === "true";
      }
      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.form.reportValidity()) {
          return;
        }

        // Guardie: (1) lo stesso <product-form> è renderizzato anche da
        // quick-view e featured-product fuori dalla PDP — il check sul body
        // tiene il funnel pulito come per "product viewed"; (2) il re-attach
        // del nodo registra un secondo listener submit (comportamento
        // pre-esistente del tema) — il flag sull'evento garantisce UNA
        // capture per submit reale.
        if (
          bkrmPosthogReady() &&
          !evt.__bkrmCtaTracked &&
          document.body.classList.contains("template-product")
        ) {
          evt.__bkrmCtaTracked = true;
          const tmpl = this.getAttribute("template") || "";
          bkrmCaptureCta({
            // Sul template asta il submit è l'ingresso al flusso offerta, non
            // un add-to-cart diretto.
            cta_type: tmpl.indexOf("asta") !== -1 ? "place_bid" : "add_to_cart",
            // Il bottone sticky vive in product-add-to-cart-sticky.liquid ma
            // sottomette QUESTO form via attributo form=: il suo id è l'unico
            // modo per distinguere la superficie.
            surface:
              evt.submitter && evt.submitter.id === "AddToCartSticky"
                ? "sticky"
                : "inline",
            product_id: this.dataset.productId || undefined,
            product_type: this.dataset.productType || undefined,
            template_suffix: tmpl || undefined,
          });
        }

        // Bici: niente add automatico. Apri il configuratore "Complete your
        // bike"; la bici entra nel carrello solo al "Procedi" (atomic add).
        if (this.dataset.bkrmConfigurator === 'true') {
          // The bike no longer hits /cart/add on this click, so the PR #81
          // stale-availability self-correction that used to run in the 422
          // handler would never fire. Re-fetch live availability here so a
          // size that sold out between page load and click still locks the
          // PDP button to "sold out" (the configurator's /cart/add.js at
          // "Procedi" is the backstop for the actual purchase).
          const variantSelects = document.querySelector(
            `variant-selects[data-section="${this.dataset.section}"]`
          );
          if (
            variantSelects &&
            typeof variantSelects.refreshAvailability === "function"
          ) {
            variantSelects.refreshAvailability();
          }
          const configurator = document.querySelector('bike-configurator');
          if (configurator && typeof configurator.open === 'function') {
            configurator.dataset.bikeVariantId = this.form.querySelector('[name=id]').value;
            configurator.open();
          } else {
            console.warn('[bkrm] bike-configurator not found or not ready — add-to-cart blocked');
          }
          return; // always block the direct add for bike forms
        }

        const submitButtons = document.querySelectorAll(
          ".single-add-to-cart-button"
        );

        submitButtons.forEach((submitButton) => {
          if (submitButton.classList.contains("loading")) return;
          submitButton.setAttribute("aria-disabled", true);
          submitButton.classList.add("loading");
        });

        this.handleErrorMessage();

        const config = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
        };

        let formData = new FormData(this.form);

        formData.append(
          "sections",
          this.getSectionsToRender().map((section) => section.section)
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              dispatchCustomEvent("product:variant-error", {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              // The variant looked available from page-load data but Shopify
              // rejected the add (commonly a 422 — last unit sold between page
              // load and click). Re-fetch live availability so the button and
              // size selector correct themselves to "sold out" instead of
              // leaving an enabled button that keeps failing. If the variant is
              // actually still available (e.g. a bike "already in cart" 422),
              // refreshAvailability() leaves the button untouched.
              const variantSelects = document.querySelector(
                `variant-selects[data-section="${this.dataset.section}"]`
              );
              if (
                variantSelects &&
                typeof variantSelects.refreshAvailability === "function"
              ) {
                variantSelects.refreshAvailability();
              }
              return;
            }

            this.renderContents(response);

            dispatchCustomEvent("cart:item-added", {
              product: response.hasOwnProperty("items")
                ? response.items[0]
                : response,
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButtons.forEach((submitButton) => {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("aria-disabled");
            });
          });
      }

      getSectionsToRender() {
        return [
          {
            id: "Cart",
            section: "main-cart",
            selector: ".thb-cart-form",
          },
          {
            id: "Cart-Drawer",
            section: "cart-drawer",
            selector: ".cart-drawer",
          },
          {
            id: "cart-drawer-toggle",
            section: "cart-bubble",
            selector: ".thb-item-count",
          },
        ];
      }
      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          // #cart-drawer-toggle is rendered twice (mobile + desktop header variants).
          // querySelectorAll catches both so the visible badge updates on every viewport.
          const containers = document.querySelectorAll("#" + section.id);
          if (!containers.length) {
            return;
          }
          const newInner = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
          containers.forEach((container) => {
            const elementToReplace =
              container.querySelector(section.selector) || container;
            elementToReplace.innerHTML = newInner;
          });

          if (typeof CartDrawer !== "undefined") {
            new CartDrawer();
          }
          if (typeof Cart !== "undefined") {
            new Cart().renderContents(parsedState);
          }
        });

        let product_drawer = document.getElementById("Product-Drawer"),
          search_drawer = document.getElementById("Search-Drawer");

        if (search_drawer.classList.contains("active")) {
          search_drawer.classList.remove("active");
        }
        if (product_drawer && product_drawer.contains(this)) {
          product_drawer.classList.remove("active");
          this.body.classList.remove("open-cc--product");
          if (
            document.getElementById("Cart-Drawer") &&
            window?.location.pathname !== "/cart"
          ) {
            this.body.classList.add("open-cc");
            document.getElementById("Cart-Drawer").classList.add("active");
          }
        } else if (document.getElementById("Cart-Drawer")) {
          this.body.classList.add("open-cc");
          document.getElementById("Cart-Drawer").classList.add("active");
          dispatchCustomEvent("cart-drawer:open");
        }
      }
      getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector).innerHTML;
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get("product-add-to-cart-sticky")) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled =
        document.body.classList.contains("animations-true") &&
        typeof gsap !== "undefined";
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector(".product-add-to-cart-sticky--inner"),
        content = this.querySelector(".product-add-to-cart-sticky--content");

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add("sticky-open");
          },
          onReverseComplete: () => {
            button.classList.remove("sticky-open");
          },
        });

        tl.set(
          content,
          {
            display: "block",
            height: "auto",
          },
          "start"
        ).from(
          content,
          {
            height: 0,
            duration: 0.25,
          },
          "start+=0.001"
        );

        button.addEventListener("click", function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener("click", function () {
          content.classList.toggle("active");
          return false;
        });
      }
    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach((entry) => {
              if (entry.target === footer) {
                if (entry.intersectionRatio > 0) {
                  _this.classList.remove("sticky--visible");
                } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                  _this.classList.add("sticky--visible");
                }
              }
              if (entry.target === form) {
                let boundingRect = form.getBoundingClientRect();

                if (
                  entry.intersectionRatio === 0 &&
                  window.scrollY > boundingRect.top + boundingRect.height
                ) {
                  _this.formPassed = true;
                  _this.classList.add("sticky--visible");
                } else if (entry.intersectionRatio === 1) {
                  _this.formPassed = false;
                  _this.classList.remove("sticky--visible");
                }
              }
            });
          },
          {
            threshold: [0, 1],
          }
        ),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById("footer");
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define("product-add-to-cart-sticky", ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get("side-panel-links")) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll("button");
      this.drawer = document.getElementById("Product-Information-Drawer");
      this.buttons = this.drawer.querySelector(".side-panel-content--tabs");
      this.panels = this.drawer
        .querySelector(".side-panel-content--inner")
        .querySelectorAll(".side-panel-content--tab-panel");
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {}
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener("click", (e) => {
          this.body.classList.add("open-cc");
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add("active");
        });
      });
    }
  }

  customElements.define("side-panel-links", ProductSidePanelLinks);
}

/**
 * Collassa i picker taglia/colore a UNA riga con tile "+N" (Figma
 * 7069-11466, feedback Mattia 31-07): i valori che sforano la prima riga
 * vengono nascosti e sostituiti da un bottone che li riespande al click.
 * Misura il layout reale (offsetTop), quindi è un no-op dove il layout non
 * c'è (jsdom) o dove tutto sta già su una riga. Se il valore selezionato
 * finisse tra i nascosti il picker resta espanso: la selezione non deve
 * mai sparire dietro il "+N".
 */
function bkrmCollapseOptionRows(root) {
  var pickers = root.querySelectorAll(
    ".variations > .product-form__input--block, .variations > .product-form__input--color"
  );
  pickers.forEach(function (fs) {
    if (getComputedStyle(fs).display === "none") return;
    // L'utente ha espanso col "+N": non ri-collassare sotto le sue mani.
    if (fs.dataset.bkrmExpanded) return;
    // Reset e RIMISURA a ogni run: le label cambiano dimensione dopo il
    // primo passaggio (applySwatches, inline in product-information.liquid,
    // le converte in pallini compatti a DOMContentLoaded) — una misura
    // fatta prima nasconderebbe troppi valori lasciando la riga mezza
    // vuota. Il run post-swatch arriva dal listener nel bootstrap sotto.
    var old = fs.querySelector(".pdp-buybox-more-values");
    if (old) old.remove();
    fs.querySelectorAll(".pdp-buybox-value-hidden").forEach(function (l) {
      l.classList.remove("pdp-buybox-value-hidden");
    });
    var labels = Array.prototype.filter.call(fs.children, function (el) {
      return el.tagName === "LABEL";
    });
    if (labels.length < 2) return;
    var firstTop = labels[0].offsetTop;
    var overflow = labels.filter(function (l) {
      return l.offsetTop > firstTop + 4;
    });
    if (!overflow.length) return;
    var checkedHidden = overflow.some(function (l) {
      var input = document.getElementById(l.htmlFor);
      return input && input.checked;
    });
    if (checkedHidden) return;
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "pdp-buybox-more-values";
    // Stesso ingombro dei selettori veri (pallini colore o pill taglia).
    btn.style.height = labels[0].offsetHeight + "px";
    btn.style.minWidth = labels[0].offsetWidth + "px";
    fs.appendChild(btn);
    overflow.forEach(function (l) {
      l.classList.add("pdp-buybox-value-hidden");
    });
    // Anche il "+N" deve stare in prima riga: se sborda, nascondi altri
    // valori dal fondo finché non rientra.
    var visible = labels.filter(function (l) {
      return overflow.indexOf(l) === -1;
    });
    while (visible.length > 1 && btn.offsetTop > firstTop + 4) {
      var last = visible.pop();
      overflow.push(last);
      last.classList.add("pdp-buybox-value-hidden");
    }
    btn.textContent = "+" + overflow.length;
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-label", "+" + overflow.length);
    btn.addEventListener("click", function () {
      fs.dataset.bkrmExpanded = "true";
      overflow.forEach(function (l) {
        l.classList.remove("pdp-buybox-value-hidden");
      });
      btn.remove();
    });
  });
}

/**
 * Rifiniture JS del buy-box sui contenitori marcati dal Liquid
 * (data-bkrm-buybox-experiment, solo template bici/frameset non-asta):
 * quello che il CSS non può fare da solo. Le classi di stile
 * (pdp-buybox-base/v2, pdp-bid-cta-a) arrivano tutte server-side —
 * qui non si sceglie più nessuna variante.
 */
function bkrmApplyBuyboxVariant() {
  var roots = document.querySelectorAll(
    ".product-information--inner[data-bkrm-buybox-experiment]"
  );
  if (!roots.length) return;
  roots.forEach(function (root) {
    // Il restyle CSS è già attivo via .pdp-buybox-base (classe server-side);
    // qui le trasformazioni che il CSS non può fare.
    // Chip sconto in formato Figma "-X%" (il testo server-rendered è
    // "Save X%"): riscrive il testo iniziale e aggiorna il template così
    // updateSavingPercentage mantiene il formato ai cambi variante.
    root.querySelectorAll('[id^="p-disc-"]').forEach(function (chip) {
      if (chip.dataset.bkrmPctFormat) return;
      chip.dataset.bkrmPctFormat = "true";
      chip.dataset.saveTemplate = "-__PCT__";
      var m = (chip.textContent || "").match(/(\d+)\s*%/);
      if (m) chip.textContent = "-" + m[1] + "%";
    });
    // Nota del box bid con offerta minima dinamica (Figma 7069-11510):
    // il floor viene dalla matrice offerte del configuratore e dipende
    // dalla variante selezionata → niente dedup, ricalcolato a ogni
    // apply (renderProductInfo ri-invoca l'applier al cambio variante).
    // Se qualcosa manca (engine non caricato, prezzo assente) resta la
    // copy statica renderizzata dal Liquid.
    var bidNote = root.querySelector(".pdp-buybox-bid-note");
    if (bidNote && bidNote.dataset.bidNoteTemplate) {
      try {
        var bidCfg = document.querySelector(
          "bike-configurator:not([data-edit-mode])"
        );
        if (
          bidCfg &&
          typeof bidCfg._bidAnchors === "function" &&
          window.Shopify &&
          typeof window.Shopify.formatMoney === "function"
        ) {
          var bidFloor = bidCfg._bidAnchors().floor;
          if (bidFloor > 0) {
            bidNote.textContent = bidNote.dataset.bidNoteTemplate.replace(
              "__MIN__",
              window.Shopify.formatMoney(Math.round(bidFloor * 100))
            );
          }
        }
      } catch (e) {
        /* copy statica */
      }
    }
    // Nel nuovo design il "Learn more" è nascosto (CSS): il modal Rider
    // Protection si apre cliccando la label verde. role/tabindex/keydown
    // perché la label è uno span e deve restare usabile da tastiera.
    var rpLabel = root.querySelector(".bk-rp-label");
    var rpOpen = root.querySelector(".bk-rp-more-inline");
    if (rpLabel && rpOpen && !rpLabel.dataset.bkrmRpWired) {
      rpLabel.dataset.bkrmRpWired = "true";
      rpLabel.setAttribute("role", "button");
      rpLabel.setAttribute("tabindex", "0");
      rpLabel.addEventListener("click", function () {
        rpOpen.click();
      });
      rpLabel.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          rpOpen.click();
        }
      });
    }
    // Picker taglia/colore su una riga con "+N" (Figma 7069-11466).
    bkrmCollapseOptionRows(root);
  });
}

// Nessuna dipendenza da PostHog: le rifiniture girano subito e poi a
// ogni evento che può cambiare la misura del layout.
if (
  document.querySelector(
    ".product-information--inner[data-bkrm-buybox-experiment]"
  )
) {
  bkrmApplyBuyboxVariant();
  // applySwatches (inline in product-information.liquid) compatta le label
  // colore a DOMContentLoaded, DOPO l'eval di questo script: il collasso
  // "+N" va rimisurato a valle. Se DOMContentLoaded è già passato il
  // listener non scatta, ma allora l'apply qui sopra ha già misurato le
  // label post-swatch.
  document.addEventListener("DOMContentLoaded", function () {
    bkrmApplyBuyboxVariant();
  });
  // I picker non devono MAI andare su due righe (feedback 03-08): la
  // misura del collasso vale solo per la larghezza corrente, quindi va
  // rifatta quando cambia — resize/rotazione (debounced) e load completo
  // (font caricati che allargano le pill). L'applier resetta e rimisura a
  // ogni run; i picker espansi dall'utente restano espansi (bkrmExpanded).
  var bkrmCollapseResizeT;
  window.addEventListener("resize", function () {
    clearTimeout(bkrmCollapseResizeT);
    bkrmCollapseResizeT = setTimeout(bkrmApplyBuyboxVariant, 150);
  });
  window.addEventListener("load", function () {
    bkrmApplyBuyboxVariant();
  });
}
